<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
      <span class="font-semibold text-primario text-lg tracking-wide">{{ $t("lang.msg.agents") }}</span>
      <div class="flex space-x-2 w-full md:max-w-lg">
        <ButtonAction @action="toggleActive" color="gray" large>
          {{ showActive ? $t('lang.msg.viewDisactives') : $t('lang.msg.viewActives') }}
        </ButtonAction>
        <ButtonRedirect route="newAgent" color="gray" >
          {{ $t('lang.msg.add') }}
        </ButtonRedirect>
      </div>
    </div>
    <datatable
      :data="data"
      :headers="headers"
      @on-row-click="openItemView"
    />
  </div>
</template>

<script>
import AdminMixin from "@/components/mixins/AdminMixin";
import DataTable from "@/components/shared/DataTable";

export default {
  name: "Agents",
  mixins: [AdminMixin],
  components: {
    datatable: DataTable
  },
  data() {
    return {
      data: [],
      headers: {
        idFactoryAgent: "#",
        factoryAgentName: `${this.$t("lang.msg.nameAndLastname")} `,
        factoryAgentPhone: this.$t("lang.fields.phone"),
        factoryAgentOrigen: this.$t("lang.msg.origin"),
        active: {
          name: this.$t("lang.msg.active"),
          type: Boolean
        }
      }
    };
  },
  created() {
      this.fetchData(`api/FactoryAgents/GetFactoryAgent`);
  },
  methods: {
    openItemView(item) {
        this.$router.push({
            name: "adminAgentDetail",
            params: {
                idFactoryAgent: item.idFactoryAgent
            }
        });
    }
  }
};
</script>
